import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import type { MailboxInfo } from "owa-client-types";
import { getCalendarConfigurationState } from "./getCalendarConfigurationState";

export const getCalendarConfigWorkingHoursTimeZoneId = (mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()): string | undefined => getCalendarConfigurationState(mailboxInfo).calendarConfiguration?.WorkingHoursTimeZone
    ?.TimeZoneId;
